import { Target } from "lucide-react";
import {
  formatAccuracy,
  PROP_LABEL,
  ACCURACY_PROPS,
  type AccuracyResult,
} from "../lib/accuracyIndex";

export function AccuracyBadge({
  result,
  areaAcres,
  variant = "panel",
}: {
  result: AccuracyResult | null;
  areaAcres?: number;
  variant?: "panel" | "corner";
}) {
  if (!result || !Number.isFinite(result.index)) return null;
  const fmt = (v: number) => (v < 10 ? v.toFixed(1) : String(Math.round(v)));
  const tip =
    "Accuracy Index — as accurate as a grid sampled at this many acres/sample (LOWER = better)\n" +
    ACCURACY_PROPS.map(
      (p) => `${PROP_LABEL[p]}: ${fmt(result.byProp[p])}`,
    ).join("   ") +
    (result.flags.length
      ? `\n${result.flags.join(", ").replace(/_/g, " ")}`
      : "");
  const text = formatAccuracy(result, areaAcres);

  if (variant === "corner") {
    return (
      <div
        className="pointer-events-auto flex items-center gap-1 rounded bg-raised/95 px-1.5 py-0.5 text-[9px] font-medium text-fg shadow"
        title={tip}
      >
        <Target size={10} className="text-accent" />
        <span className="text-muted">Accuracy Index:</span>
        <span className="tabular-nums text-fg">{text}</span>
      </div>
    );
  }
  return (
    <div
      className="flex items-center justify-between gap-2 rounded bg-accent/10 px-1.5 py-1"
      title={tip}
    >
      <span className="flex items-center gap-1 text-[10px] font-medium text-muted">
        <Target size={11} className="text-accent" /> Accuracy Index
      </span>
      <span className="text-[11px] font-semibold tabular-nums text-fg">
        {text}
      </span>
    </div>
  );
}
